function SideNavLoadingIndicator(): JSX.Element {
  return (
    <div className="bg-sideNavGray border-r py-6 px-5 overflow-hidden">
      <div className="p-2 bg-dropDownBorder rounded-lg  mb-3 w-full animate-pulse" />
      <div className="p-2 bg-dropDownBorder rounded-lg  mb-3 w-full animate-pulse" />
      <div className="p-2 bg-dropDownBorder rounded-lg  mb-3 w-full animate-pulse" />
      <div className="p-2 bg-dropDownBorder rounded-lg  mb-3 w-full animate-pulse" />
    </div>
  );
}

export default SideNavLoadingIndicator;
